import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Star, MapPin } from "lucide-react";
import { DealCard } from "@/pages/Home";

export default function TherapistProfile() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/therapists/${id}`).then(r => setData(r.data)).catch(e => setErr(e.response?.data?.detail || "Not found"));
  }, [id]);

  if (err) return <div className="max-w-3xl mx-auto px-6 py-24 text-center font-serif-display text-3xl">{String(err)}</div>;
  if (!data) return <div className="max-w-3xl mx-auto px-6 py-24 text-center text-[#5F6C60]">Loading…</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#5F6C60]">{data.role === "business" ? "Massage business" : "Individual therapist"}</div>
      <h1 className="font-serif-display text-5xl tracking-tighter mt-2">{data.business_name || data.name}</h1>
      {data.avg_rating != null && (
        <div className="mt-3 flex items-center gap-2 text-sm">
          <div className="flex gap-0.5 text-[#D97757]">
            {[1,2,3,4,5].map(i => <Star key={i} className={`w-4 h-4 ${i <= Math.round(data.avg_rating) ? "fill-current" : ""}`} strokeWidth={1.5}/>)}
          </div>
          <span className="font-medium">{data.avg_rating}</span>
          <span className="text-[#5F6C60]">· {data.review_count} review{data.review_count===1?'':'s'}</span>
        </div>
      )}

      <div className="mt-12">
        <h2 className="font-serif-display text-3xl tracking-tight mb-6">Live deals</h2>
        {data.deals.length === 0 ? (
          <p className="text-[#5F6C60]">No active deals right now.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {data.deals.map(d => <DealCard key={d.id} deal={d} />)}
          </div>
        )}
      </div>

      {data.reviews.length > 0 && (
        <div className="mt-16">
          <h2 className="font-serif-display text-3xl tracking-tight mb-6">Recent reviews</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {data.reviews.map(r => (
              <div key={r.id} className="bg-white border border-[#E8E2D6] rounded-2xl p-5">
                <div className="flex gap-0.5 text-[#D97757] mb-2">
                  {[1,2,3,4,5].map(i => <Star key={i} className={`w-3.5 h-3.5 ${i <= r.rating ? "fill-current" : ""}`} strokeWidth={1.5}/>)}
                </div>
                <p className="text-[#2C352D]">{r.body}</p>
                <div className="text-xs text-[#5F6C60] mt-3">— {r.customer_name} · {r.created_at?.slice(0,10)}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
